import { render, staticRenderFns } from "./popup-result.mpx?vue&type=template&id=0e24f082&scoped=true&isComponent&outputPath=components%2Fpopup-result17d2ec4c%2Findex"
import script from "./popup-result.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fpopup-result17d2ec4c%2Findex"
export * from "./popup-result.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fpopup-result17d2ec4c%2Findex"
import style0 from "./popup-result.mpx?vue&type=style&index=0&id=0e24f082&prod&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m17d2ec4c%22%7D&isComponent&outputPath=components%2Fpopup-result17d2ec4c%2Findex"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e24f082",
  null
  
)

export default component.exports